import { fontSizes, getFont, measurements, colors } from 'app/theme'
import css from 'styled-jsx/css'

export default css`
.tandc{
    color:${colors.primary};
}
p{
    font-size:.7rem;
}
`
